import { useApi } from "./useApi";
import { useAuth } from "./useAuth";
import { useLoading } from "./useLoading";
import { usePaginatedQuery } from "./usePaginatedQuery";
import { useService } from "./useService";
import { useRouteAccess } from "./useRouteAccess";
export {
  useAuth,
  useApi,
  useLoading,
  usePaginatedQuery,
  useRouteAccess,
  useService,
};

export default {
  useAuth,
  useApi,
  useLoading,
  usePaginatedQuery,
  useRouteAccess,
  useService,
};
